import { Injectable } from '@angular/core';
import { IMenuList } from '@fpx/core/models';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor() {}

  private toggleNav = new BehaviorSubject<boolean>(true);
  public expandNav$ = this.toggleNav.asObservable();
  private successMessage?: string | undefined;
  private failureMessage?: string | undefined;
  private warningMessage?: string | undefined;
  private serviceDescription: string = '';
  private category?: string | undefined;
  private module?: string | undefined;
  private navigationPath?: string[] | undefined;
  private id: string = '';
  private icon?: string | undefined;
  private child?: IMenuList[] | undefined;
  private title?: string | undefined;
  private serviceCode: string = '';
  private collapsedNav: boolean = true;
  private queryParam : any;

  setMenuData(menu: IMenuList) {
    Object.assign(this, menu);
  }

  getValue(key: keyof IMenuList): any {
    return this[key];
  }

  expandSideNav(): void {
    this.collapsedNav = !this.collapsedNav;
    this.toggleNav.next(this.collapsedNav);
  }
}
